"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingOverlay = exports.TEST_ID = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const loader_1 = require("@nib/loader");
const logo_1 = __importDefault(require("@nib-components/logo"));
const copy_1 = __importDefault(require("@nib-components/copy"));
const heading_1 = __importDefault(require("@nib-components/heading"));
const S = __importStar(require("./LoadingOverlay.style"));
const LoadingOverlay_content_1 = __importDefault(require("./LoadingOverlay.content"));
exports.TEST_ID = "LoadingOverlay__TestId";
const LoadingOverlay = () => (0, jsx_runtime_1.jsx)(S.Wrapper, {
  "data-testid": exports.TEST_ID,
  children: (0, jsx_runtime_1.jsxs)(S.InnerWrapper, {
    children: [(0, jsx_runtime_1.jsx)(logo_1.default, {
      height: "80px"
    }), (0, jsx_runtime_1.jsxs)(S.LoadingContainer, {
      children: [(0, jsx_runtime_1.jsx)(heading_1.default, {
        size: 3,
        children: LoadingOverlay_content_1.default.LOADING
      }), (0, jsx_runtime_1.jsx)(copy_1.default, {
        children: LoadingOverlay_content_1.default.LOADING_SUBTITLE
      })]
    }), (0, jsx_runtime_1.jsx)(loader_1.Loader, {
      size: "md"
    })]
  })
});
exports.LoadingOverlay = LoadingOverlay;